export const LIST_POLICE_PRIM_REQUEST = 'LIST_POLICE_PRIM_REQUEST';
export const LIST_POLICE_PRIM_SUCCESS = 'LIST_POLICE_PRIM_SUCCESS';
export const LIST_POLICE_PRIM_FAILURE = 'LIST_POLICE_PRIM_FAILURE';

export const LIST_POLICE_PRIM_LOADING='LIST_POLICE_PRIM_LOADING';
